import { render, staticRenderFns } from "./envelope-title.vue?vue&type=template&id=20adbd20"
import script from "./envelope-title.vue?vue&type=script&lang=js"
export * from "./envelope-title.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports